import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/provider-network/')({
  beforeLoad: () => {
    throw redirect({
      to: '/provider-network/clinics',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
  },
});
